import { useAuth0 } from '@auth0/auth0-react';

import { PropsWithChildren, useEffect, useState } from 'react';

export const StripeCustomerIDWrapper = ({ children }: PropsWithChildren<any>) => {
  const { getIdTokenClaims, logout } = useAuth0();

  const [hasStripeCustomerID, setHasStripeCustomerID] = useState(false);

  // Logout user they don't have stripe_customer_id so that it can generate on login
  useEffect(() => {
    async function checkStripeCustomerID() {
      const token = await getIdTokenClaims();
      if (!token?.stripe_customer_id) {
        logout();
      }
      setHasStripeCustomerID(true);
    }
    if (!hasStripeCustomerID) {
      checkStripeCustomerID();
    }
  }, [getIdTokenClaims, hasStripeCustomerID, logout]);

  return children;
};
